module.exports = __webpack_public_path__ + "static/img/mockup03.53ad518.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/sachassou/mockup03.jpg
// module id = wl9H
// module chunks = 1